var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"color":"primary","loading":_vm.isLoading,"disabled":_vm.isLoading},on:{"click":_vm.download}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.titleText)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-download ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }